<div class="panel">

  <div class="panel__header" style="display: flex;
  flex-direction: column;
  align-items: baseline;">

    <div class="panel__header">
      <a class="square-button" (click)="openMenu()" style="    cursor: pointer;">
        <i class="material-icons square-button__icon">menu</i>
      </a>



      <mat-select (selectionChange)="ObservationPointMenuItemSelect($event.value)" class="select-class" #mySelect
        [(ngModel)]="SelectedObsPoint">

        <mat-optgroup *ngFor="let group of ObsHistoryMenuList" [label]="group.name" [disabled]="group.disabled">
          <mat-option *ngFor="let pokemon of group.ObservationPointList" [value]="pokemon.id">
            {{pokemon.name}}
          </mat-option>
        </mat-optgroup>
      </mat-select>



    </div>


    <span style="font-size: 18px;">
      <b> Observation Point : </b> {{ arrInspectionTypes[0].ObservationDetails.ObsName}}
    </span>
    <div *ngFor="let InsType of arrInspectionTypes" style="display: flex;
  flex-direction: column;
  flex: 1;
  align-items: baseline;">


      <div class="header__title-container">
        <span class="panel__header__title">{{InsType.FECRInspectionType}}</span>
      </div>

      <div style="display: flex;margin-top: 20px;width: 100%;">

        <span  style="align-items: center;
     
      display: flex;
      margin-right: 20px;width: 100px;">Images</span>
        <ng-container *ngFor="let imagesData of InsType.ObservationDetails.ObservationImage">
          <img style="width: 300px;
  height: 300px;
  margin-right: 10px;" [src]="getImage(imagesData.image)" />
        </ng-container>

        <ng-container
          *ngIf="!InsType.ObservationDetails.ObservationImage ||InsType.ObservationDetails.ObservationImage.length == 0">
          <span>No Images Found</span>
        </ng-container>


      </div>

      <div style="display: flex;margin-top: 20px;width: 100%;">

        <span  style="align-items: center;display: flex;
      margin-right: 20px;width: 100px;">Comment</span>

        <textarea *ngIf="InsType.ObservationDetails.ObservationComment"  class="textAreaComment" rows="4" maxlength="256" disabled
          placeholder="Observation Point Comment. ">{{InsType.ObservationDetails.ObservationComment}}</textarea>

        <span *ngIf="!InsType.ObservationDetails.ObservationComment">No Comments Found</span>

      </div>

    </div>

    <div *ngFor="let InsType of arrInspectionTypes" style="display: flex;
  flex-direction: column;
  flex: 1;
  align-items: baseline;">


      <div class="header__title-container">
        <span class="panel__header__title">Progress Reporting Inspection</span>
      </div>
      <ng-container *ngFor=" let info of InsType.ProgressReportingDetails">
        <div style="display: flex;margin-top: 20px;width: 100%;">

          <span  style="align-items: center;display: flex;margin-right: 20px;width: 100px;">Record Details</span>

          <span >{{info.Inspector}} - {{info.RecordDate}}</span>

        </div>
        <div style="display: flex;margin-top: 20px;width: 100%;">

          <span  style="align-items: center;display: flex;margin-right: 20px;width: 100px;">Complete Percentage(%)</span>

          <span  >{{info.completePercentage}} %</span>

        </div>
        <div style="display: flex;margin-top: 20px;width: 100%;">

          <span style="align-items: center; display: flex;margin-right: 20px;width: 100px;">Images</span>
       
          <ng-container *ngFor="let imagesData of info.ImageList">
        
            <img style="width: 300px;height: 300px;margin-right: 10px;" [src]="getImage(imagesData)" />
          </ng-container>

          <ng-container *ngIf="info.ImageList == null ||info.ImageList.length == 0">
            <span >No Images Found</span>
          </ng-container>


        </div>

        <div style="display: flex;margin-top: 20px;width: 100%;">

          <span  style="align-items: center;display: flex;margin-right: 20px;width: 100px;">Comment</span>

          <textarea *ngIf="info.Comment" rows="4" maxlength="256" disabled class="textAreaComment"
            placeholder="Observation Point Comment. ">{{info.Comment}}</textarea>

          <span *ngIf="!info.Comment">No Comments Found</span>

        </div>
      </ng-container>


    </div>
  </div>


</div>